export function WordList(props) {
    const wordsLeft = [];
    const wordsRight = [];
    for (var w=0; w < props.words.length; w++) {
        const word = props.words[w];
        const found = props.foundWords.indexOf(word) != -1;

        (w < props.words.length/2 ? wordsLeft : wordsRight).push(<WordListWord word={word} found={found}/>)
    }
    
    return (
        <div className="wordList" style={{width: props.maxWidth}}>
            <div className="wordListColumn">
                {wordsLeft}
            </div>
            <div className="wordListColumn">
                {wordsRight}
            </div>

        </div>

    )
}

export function WordListWord(props) {
    return (
        <div>
            <span className={"wordListWord " + (props.found ? "found" : "")}>
                {props.word}
            </span>
        </div>
    )
}